module.exports = __webpack_public_path__ + "static/media/solutions.a1a059b4.png";